var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
var eventer = window[eventMethod];
var messageEvent = eventMethod == 'attachEvent' ? 'onmessage'  : 'message';

eventer(messageEvent, function (e) {
  if (e.data == 'CloseWidget') {
    $('#appointmentModal').modal('hide');
  }
});

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.hash == '#appointment') {
    if ($('#appointmentModal').length > 0) {
      $('#appointmentModal').modal('show');
    }
  }

  const appointmentLinks = document.querySelectorAll('a[href=\'#appointment\']');

  if ($('#appointmentModal').length > 0) {
    for (let i = 0; i < appointmentLinks.length; i++) {
      appointmentLinks[i].addEventListener('click', (e) => {
        e.preventDefault();
        $('#appointmentModal').modal('show');
      });
    }
  }
}, false);
